export const config = {
    site_url : "https://unique-name-generator.web.app",
    api_url:"https://api.teskill.com/api/namegen/v1"
    // api_url : "http://127.0.0.1:5000"
}